module.exports = __webpack_public_path__ + "static/media/gutes_entdecken.7cebe17a.jpg";